import Houdini from "houdinijs";
import Url from "url-parse";
const $ = require("jquery");

$(document).ready(function() {
  const accordionList = document.querySelector(".accordion__list");

  if (accordionList === null) {
    return;
  }

  let disclosure = new Houdini("[data-houdini-dl] dd", {
    isAccordion: true,
    collapseOthers: true,
    headingClass: "accordion__item__header",
    btnClass: "accordion__item__title",
    icon: false
  });

  let url = new Url(window.location.href, true);
  if (url.hash) {
    if (url.hash === "#open-modal") {
      return;
    }
    disclosure.expand(url.hash);
  }
});

let logHoudiniEvent = function(event) {
  const accordionList = document.querySelector(".accordion__list");

  if (accordionList === null) {
    return;
  }

  let hash = "#" + event.detail.button.dataset.houdiniToggle;
  let url = new Url(window.location.href, true);
  url.hash = hash;
  history.pushState({}, null, url);

  event.detail.button.scrollIntoView({ behavior: "smooth" });
};

document.addEventListener("houdiniExpand", logHoudiniEvent, false);
